import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { ThemeContext } from "../../Context/theme";
import profilePic from "../../assets/nayan3.jpeg";
 

export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img src={profilePic} alt="Images" />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi Everyone, I,m {" "}
                <span className="different">Gyan Prakash </span> from{" "}
                <span className="different">
                  {" "}
                  Ballia,Uttar Pradesh (India).
                </span>
                I have completed my Graduation in English Honours from{" "}
                <span className="different">
                Jananayak Chandrashekhar University, Ballia (U.P).
                </span>
                Then I joined a full stack development course by{" "}
                <span className="different">Masai School</span> a military-style
                coding school.
              </h4>
              <h4> Some of my interests apart form Coding :</h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Travelling{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Playing Chess{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Teaching and Motivation{" "}
              </h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
